module.exports = __webpack_public_path__ + "img/subscription_badge.c4610027.svg";